module.exports = __webpack_public_path__ + "static/media/banner_beauty@2x.328d3d2d.png";